var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"generic-header",class:( _obj = {}, _obj[("generic-header--" + _vm.variant)] = _vm.variant, _obj )},[_c('div',{staticClass:"generic-header__title"},[_vm._t("default")],2),_c('div',{staticClass:"generic-header__side"})])}
var staticRenderFns = []

export { render, staticRenderFns }